export const RetailerTypesOptions = [
  {
    value: "Entertainment",
    label: "Entertainment",
  },
  {
    value: "Food & Drink",
    label: "Food & Drink",
  },
  {
    value: "Beauty",
    label: "Beauty",
  },
  {
    value: "Fashion",
    label: "Fashion",
  },
  {
    value: "Home",
    label: "Home",
  },
  {
    value: "Tech",
    label: "Tech",
  },
  {
    value: "Supermarkets",
    label: "Supermarkets",
  },
  {
    value: "Health",
    label: "Health",
  },
  {
    value: "Travel",
    label: "Travel",
  },
  {
    value: "Digital Credit",
    label: "Digital Credit",
  },
];

export const Top10Options = [
  {
    value: "none",
    label: "None",
  },
  {
    value: 1,
    label: 1,
  },
  {
    value: 2,
    label: 2,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 4,
    label: 4,
  },
  {
    value: 5,
    label: 5,
  },
  {
    value: 6,
    label: 6,
  },
  {
    value: 7,
    label: 7,
  },
  {
    value: 8,
    label: 8,
  },
  {
    value: 9,
    label: 9,
  },
  {
    value: 10,
    label: 10,
  },
  {
    value: 11,
    label: 11,
  },
  {
    value: 12,
    label: 12,
  },
  {
    value: 13,
    label: 13,
  },
  {
    value: 14,
    label: 14,
  },
  {
    value: 15,
    label: 15,
  },
  {
    value: 16,
    label: 16,
  },
  {
    value: 17,
    label: 17,
  },
  {
    value: 18,
    label: 18,
  },
  {
    value: 19,
    label: 19,
  },
  {
    value: 20,
    label: 20,
  },
];

export const RetailerFullToken = [
  {
    value: 0,
    label: "N/A",
  },
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 6,
    label: "6",
  },
  {
    value: 7,
    label: "7",
  },
  {
    value: 8,
    label: "8",
  },
  {
    value: 9,
    label: "9",
  },
  {
    value: 10,
    label: "10",
  },
];

export const RetailerPartToken = [
  {
    value: 0,
    label: "N/A",
  },
  {
    value: 0.25,
    label: "0.25",
  },
  {
    value: 0.5,
    label: "0.5",
  },
  {
    value: 0.75,
    label: "0.75",
  },
];

export const OfferRedemptionTypeOptions = [
  {
    label: "Iframe",
    value: "iframe",
  },
  {
    label: "External voucher link",
    value: "externalVoucherLink",
  },
];

export const RetailerVoucherOptions = [
  {
    label: "We Gift",
    value: "wegift",
  },
  {
    label: "Neo Currency",
    value: "neocurrency",
  },
];
export const TerritoryOptions = [
  "UK",
  "USA",
  "Ireland",
  "Canada",
  "France",
  "India",
  "German",
  "SouthAfrica",
  "Australia",
];

export const CurrencyOptions = {
  UK: "£",
  Ireland: "€",
  German: "€",
  France: "€",
  USA: "$",
  Canada: "$",
  India: "$",
  SouthAfrica: "$",
  Australia: "$",
};



// WEBPACK FOOTER //
// ./src/Constants/retailer.js